import { JSONSchema7Object, ConfigurableFormConfig } from "../../../types";
import * as formElements from "./formElements";
import validateSchema from "./customerAdditionalInfo.json";
import formElementsSchema from "./formElements.json";

export const formConfig: ConfigurableFormConfig = {
  fields: [
    {
      ...formElements.sectionHeader,
      label: "customer.additionalInfo.page.title"
    },
    {
      ...formElements.sectionText,
      label: "customer.additionalInfo.page.body"
    },
    // Only display the title if the customer's language is Japanese and the store's country is Japanese
    {
      ...formElements.fieldTitle,
      id: "honorificPrefix",
      name: "honorificPrefix",
      label: "customer.data.fields.honorificPrefix.label",
      props: {
        required: true
      },
      showOnlyIf: {
        all: {
          has: {
            "pageState.language": "ja",
            "appState.storeCountry": "JP"
          }
        }
      },
      errorMessage:
        "customer.additionalInfo.fields.honorificPrefix.errors.required"
    },
    {
      ...formElements.group,
      id: "customer-additional-name",
      props: {
        className: "customer-additional-name"
      },
      fields: [
        {
          ...formElements.fieldText,
          id: "givenName",
          name: "givenName",
          label: "customer.data.fields.givenName.label",
          props: {
            inputProps: {
              disabled: true
            }
          }
        },
        {
          ...formElements.fieldText,
          id: "familyName",
          name: "familyName",
          label: "customer.data.fields.familyName.label",
          props: {
            inputProps: {
              disabled: true
            }
          }
        },
        {
          ...formElements.fieldText,
          id: "alternateGivenName2",
          name: "alternateGivenName2",
          label: "customer.additionalInfo.fields.jpKanaFirstName.label",
          showOnlyIf: {
            all: {
              has: {
                "pageState.language": "ja",
                "appState.storeCountry": "JP"
              }
            }
          },
          errorMessage:
            "customer.additionalInfo.fields.jpKanaFirstName.errors.required"
        },
        {
          ...formElements.fieldText,
          id: "alternateFamilyName2",
          name: "alternateFamilyName2",
          label: "customer.additionalInfo.fields.jpKanaLastName.label",
          showOnlyIf: {
            all: {
              has: {
                "pageState.language": "ja",
                "appState.storeCountry": "JP"
              }
            }
          },
          errorMessage:
            "customer.additionalInfo.fields.jpKanaLastName.errors.required"
        },
        {
          ...formElements.fieldText,
          id: "alternateGivenName1",
          name: "alternateGivenName1",
          label: "customer.additionalInfo.fields.globalFirstName.label",
          errorMessage:
            "customer.additionalInfo.fields.globalFirstName.errors.required"
        },
        {
          ...formElements.fieldText,
          id: "alternateFamilyName1",
          name: "alternateFamilyName1",
          label: "customer.additionalInfo.fields.globalLastName.label",
          errorMessage:
            "customer.additionalInfo.fields.globalLastName.errors.required"
        }
      ]
    },
    {
      ...formElements.fieldDropdownCustom,
      id: "gender",
      name: "gender",
      label: "customer.additionalInfo.fields.gender.label",
      props: {
        inputProps: {
          searchable: true,
          options: [
            {
              label: "customer.additionalInfo.fields.gender.options.notSet",
              value: ""
            },
            {
              label: "customer.additionalInfo.fields.gender.options.male",
              value: "M"
            },
            {
              label: "customer.additionalInfo.fields.gender.options.female",
              value: "F"
            }
          ]
        }
      },
      errorMessage: "customer.additionalInfo.fields.gender.errors.required"
    }
  ],
  validateSchema: validateSchema as JSONSchema7Object,
  refSchemas: [formElementsSchema as JSONSchema7Object],
  labels: {
    buttonBack: "",
    buttonNext: "general.buttons.continue.label",
    buttonSubmit: "general.buttons.submit.label"
  }
};

export default formConfig;
